import { ReactNode, Children } from 'react';
import { Grid, GridProps } from '@mui/material';

export type Props = {
  children: ReactNode[];
  containerProps?: GridProps;
};

export const Container: React.FC<Props> = ({ children, containerProps }) => (
  <Grid container spacing={3} alignItems='stretch' {...containerProps}>
    {Children.toArray(children).map((item, i) => {
      return (
        <Grid key={i} item xs={12} md={6} lg={4}>
          {item}
        </Grid>
      );
    })}
  </Grid>
);
